module.exports = __webpack_public_path__ + "static/pitfall-04fbbb8880ba595c8be5813f422e0c0e.gif";